import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { configActions } from "./actions/configs.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class Config extends Component {
  componentDidMount() {
    this.getConfig();
  }

  componentWillUnmount() {
    this.props.resetConfig();
  }

  getConfig = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getConfig(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const config = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CONFIGS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Configurations: {config && config.name}{" "}
                  <Button
                    onClick={this.getConfig}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}

            <dl className="row">
              {/* <dt className="col-sm-3">Configuration Id</dt>
              <dd className="col-sm-9">
                {config ? (
                  config.id
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd> */}

              <dt className="col-sm-3">Configuration Name</dt>
              <dd className="col-sm-9">
                {config ? (
                  config.name
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Configuration Value</dt>
              <dd className="col-sm-9">
                {config ? (
                  config.value
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.CONFIGS.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewConfig;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getConfig: bindActionCreators(configActions.getConfig, dispatch),
    resetConfig: bindActionCreators(configActions.resetConfig, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Config);
